<ng-container *ngIf="!placeholderImageEncrypt; else placeholderTemplate">
  <ng-container *ngIf="!noImage; else noImageTemplate">
    <ng-container *ngIf="fixedWidth">
      <!-- PICTURE WITH FIXED WIDTHS -->
      <picture [class]="customClass" [class.canModal]="modal">
        <img
          *ngIf="!hasErrors"
          (click)="modal ? openModal() : null"
          [src]="generateSrcset(fixedWidth)"
          (onerror)="handleError()"
          [alt]="alt"
          [attr.data-width]="widths[lastPosition]"
          loading="lazy"
        />
      </picture>
    </ng-container>
    <ng-container *ngIf="!fixedWidth">
      <ng-container *ngIf="widths.length > 0 || (customWidths && customWidths.length > 0)">
        <ng-container
          *ngIf="!customWidths || customWidths.length === 0; then picture; else customPicture"
        ></ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<!-- PICTURE WITH NORMAL WIDTHS TEMPLATE -->
<ng-template #picture>
  <picture [class]="customClass" [class.canModal]="modal">
    <ng-container *ngFor="let w of widths; let i = index">
      <ng-container *ngIf="i > 0">
        <source
          [media]="generateMinWidth(w)"
          [srcset]="generateSrcset(widths[i - 1])"
          [attr.data-width]="widths[i - 1]"
        />
      </ng-container>
    </ng-container>
    <img
      *ngIf="!hasErrors"
      (click)="modal ? openModal() : null"
      [src]="generateSrcset(widths[lastPosition])"
      (onerror)="handleError()"
      [alt]="alt"
      [attr.data-width]="widths[lastPosition]"
      loading="lazy"
    />
  </picture>
</ng-template>

<!-- PICTURE WITH CUSTOM WIDTHS TEMPLATE -->
<ng-template #customPicture>
  <picture [class]="customClass" [class.canModal]="modal">
    <ng-container *ngFor="let cw of customWidths">
      <ng-container *ngIf="cw.b !== 'default' && cw.b !== 0">
        <source [media]="generateMinWidth(cw.b)" [srcset]="generateSrcset(cw.w)" [attr.data-width]="cw.w" />
      </ng-container>
    </ng-container>
    <img
      *ngIf="!hasErrors"
      (click)="modal ? openModal() : null"
      [src]="generateSrcsetDefaultCustomWidths()"
      (error)="handleError()"
      [alt]="alt"
      [attr.data-width]="customDefaultWidth"
      loading="lazy"
    />
  </picture>
</ng-template>

<!-- NO IMAGE TEMPLATE -->
<ng-template #noImageTemplate>
  <div
    class="noImage {{ placeholderType }}"
    [ngStyle]="{
      'width.px': customDefaultWidth ? customDefaultWidth : widths[lastPosition],
      'height.px': params.height || noImageHeight
    }"
  >
    <span> {{ channelName }}</span>
  </div>
</ng-template>

<!-- PLACEHOLDER TEMPLATE -->
<ng-template #placeholderTemplate>
  <img *ngIf="hasErrors" [src]="placeholderImageEncrypt" [alt]="alt" loading="lazy" />
</ng-template>
